// @flow

import type {AuthBloc} from "../../blocs/authBloc";
import {apiAxios} from '../../config/AxiosConfig'

class TaskListApi {

    authBloc : AuthBloc;

    constructor(authBloc: AuthBloc) {
        this.authBloc = authBloc;
    }

    async getAll() : Promise<Array<Object>> {
        const tenantId = this.authBloc.getCurrentTenant();

        const response = await apiAxios.get(`/tenants/${tenantId}/tasklists`, this.buildHeaders());

        if (response.status !== 200) {
            throw new Error(response.status);
        }

        return response.data;
    }

    async duplicate(request: Object) : Promise<Object> {
        const tenantId = this.authBloc.getCurrentTenant();

        return await apiAxios.post(`/tenants/${tenantId}/duplicate`, request, this.buildHeaders());
    }

    async applyPriceOffset(request: Object) : Promise<Object> {
        const tenantId = this.authBloc.getCurrentTenant();

        return await apiAxios.patch(`/tenants/${tenantId}/update`, request, this.buildHeaders());
    }

    buildHeaders = ()=> {
        const accessToken = this.authBloc.getCurrentToken();
        const auth = "Bearer " + accessToken;
        return {headers:{Authorization:auth}};
    }
}

export default TaskListApi;
